"use client";
import { isMatch } from "matcher";
import { usePathname } from "next/navigation";

const usePathMatcher = (paths: string[]): boolean => {
  const pathname = usePathname();
  return !!pathname && isMatch(pathname, paths);
};

export default usePathMatcher;
